import React from "react"
import { Helmet } from "react-helmet"
import style from "./style.module.scss"

export default function({ x, y, text, description, image, big }) {
  return (
    <header className={`${style.container} ${big ? style.big : ""}`}>
      <Helmet>
        <title>{text}</title>
        <meta name="description" content={description} />
        <meta name="og:image" content={image} />
      </Helmet>
      {image.split(".").pop() === "mp4" ? (
        <video autoPlay loop muted>
          <source src={image} type="video/mp4" />
        </video>
      ) : (
        <img src={image} alt={text} draggable="false" />
      )}
      <div
        className={style.line}
        style={{
          top: "10%",
          height: `${y - 10}%`,
          left: `${x}%`,
          width: `${90 - x}%`,
        }}
      />
      <div className={style.point} style={{ top: `${y}%`, left: `${x}%` }} />
      <div
        className={style.text}
        style={{
          top: "10%",
          right: "15%",
        }}
      >
        <h1>{text}</h1>
        <p>{description}</p>
      </div>
    </header>
  )
}
